import {css} from '@emotion/css';
import {Breakpoints, mq} from '../../../styles/js/mixins';
import {colours, spacing} from '../../../styles/js/variables';
import {Alignment} from '../../../types';

const getAlignment = (align: Alignment): string => {
  switch (align) {
    case Alignment.CENTER:
      return 'text-align: center;';
    case Alignment.LEFT:
      return 'text-align: left;';
    case Alignment.RIGHT:
      return 'text-align: right;';
    default:
      return 'text-align: center;';
  }
};

const styles = {
  informationBox: (align: Alignment, hasBorder = false): string => css`
    label: informationBox;
    margin: ${spacing.M} ${spacing.XS};
    padding: ${spacing.M} ${spacing.XXS};
    background-color: ${colours.background.MAIN};

    ${getAlignment(align)}
    ${hasBorder ? `border: 1px solid ${colours.border.LIGHT_GRAY};` : ''}

    ${mq(Breakpoints.TABLET)} {
      margin: ${spacing.M};
      padding: ${spacing.M};
    }
  `,
  copy: css`
    label: informationBox__copy;
    color: ${colours.font.ASSISTIVE};
  `,
};

export default styles;
